<template>
  <v-timeline-item
    :fill-dot="false"
    :hide-dot="false"
    :left="false"
    :right="false"
    :small="false"
    large
    class="diary-item"
    color="#4dbac0"
  >
    <template v-slot:icon>
      <div @click="goTodetail" class="my-dot">
        <div class="text-center dot-day pa-0">{{day}}</div>
        <div class="text-center dot-month">{{month}}</div>
      </div>
    </template>
    <v-card flat class="font px-4 py-3 card-hover">
      <div @click="goTodetail" class="width-full mb-3 pointer">
        <span class="date-font text-white">{{date}}</span>
        <img
          v-if="record.feeling>0"
          class="float-right opacity"
          style="opacity: 0.7"
          height="30"
          :src="'https://tradeinpool.com/img/emoji/'+record.feeling+'.png'"
        />
      </div>

      <div class="width-full">
        <div
          v-if="record._images.length>0"
          style="float:left; width: 70px; height: 65px;margin-right:10px"
        >
          <vue-picture-swipe small :items="record._images.slice(0,1)"></vue-picture-swipe>
        </div>
        <p style="line-height:18px;margin-bottom:2px;" class="pointer" @click="goTodetail">
          <span v-if="record.description.length>0" class="date-font text-white">{{diaryTime}}</span>
          <span v-if="record.description.length>0" class="text-font px-1">|</span>
          <span class="text-font">{{record.description.slice(0,200)}}</span>
          <span v-if="record.description.length>200" class="ml-1">...</span>
          <span @click="goTodetail" v-if="record.description.length>200" class="more ml-1">More</span>
        </p>
      </div>

      <div v-if="record.keywords.length > 1" class="width-full float-left pa-0 mb-2">
        <v-chip-group>
          <v-chip small v-for="keyword in record.keywords" :key="keyword">{{ keyword }}</v-chip>
        </v-chip-group>
      </div>

      <div v-if="record._trades.length > 0">
        <transition-group name="list">
          <div
            class="record-card"
            style="padding: 0 0 0 10px"
            v-for="(trades) in record._trades.slice(0,showCount)"
            :key="trades._id"
          >
            <Trades :trades="trades" />
          </div>
        </transition-group>
        <div
          @click="showMore = showMore ? showMore = false : true"
          class="more"
          v-if="record._trades.length > 3"
        >{{showText + " ("+totalTrades+")"}}</div>
        <div class="float-right pb-2 pr-6">
          <span class="date-font mr-3">Today P/L:</span>
          <span class="pl-font" v-bind:class="totalPL > 0 ? 'up' : 'down'">$ {{totalPL.toFixed(2)}}</span>
        </div>
      </div>
      <div v-else class="record-card pa-4 mb-6 text-font">No trading activity this day...</div>
    </v-card>
  </v-timeline-item>
</template>

<script>
var moment = require("moment-timezone");
//import VuePictureSwipe from "vue-picture-swipe";
import Trades from "./trades.vue";
export default {
  components: {
    //VuePictureSwipe,
    Trades
  },
  props: { record: Object },
  data() {
    return {
      displayImage: [],
      isActive: false,
      totalLots: 0,
      showCount: 3,
      showText: "Show all",
      showMore: false,
      timezone: this.$store.getters.timezone,
      day: null,
      month: null,
      date: null,
      diaryTime: null,
      detail: moment(this.record.date).format("YYYY-MM-DD")
    };
  },

  watch: {
    showMore(newVal) {
      if (newVal) {
        this.showText = "Hide";
        this.showCount = 999999;
      } else {
        this.showText = "Show all";
        this.showCount = 3;
      }
    }
  },
  methods: {
    goTodetail() {
      this.$router.push({
        name: "Diary",
        params: { name: this.$route.params.name, date: this.detail }
      });
    },
    updateTiems() {
      this.timezone = this.$store.getters.timezone;
      this.date = moment(this.record.date).format("dddd LL");
      this.diaryTime = moment
        .tz(this.record.createdAt, this.$store.getters.timezone)
        .format("hh:mm");
    }
  },
  created() {
    /*
    if (this.record._images.length > 0) {
      this.displayImage = this.record._images[0];
      this.displayImage[0].thumbnail = this.displayImage[0].thumbnail.replace("thumb", "mini");
    }
    */
  },
  mounted() {
    //this.record._trades.forEach(trade => {
    //  this.totalPL += trade.ClosedProfitLoss;
    //});
    this.day = moment(this.record.date).format("DD");
    this.month = moment(this.record.date).format("MMMM");

    this.updateTiems();
    setInterval(() => {
      this.updateTiems();
    }, 1000);
  },
  computed: {
    totalPL() {
      var newVal = 0;
      this.record._trades.forEach(trade => {
        newVal += trade.ClosedProfitLoss;
      });
      return newVal;
    },
    totalTrades() {
      return this.record._trades.length;
    }
  }
};
</script>

<style scoped>
</style>
